export default __webpack_public_path__ + "static/media/Col3Banner1.f2e9fea2.jpg";